module.exports = __webpack_public_path__ + "fonts/Lufthansa Text Light.7af60a88.otf";